import { purchaseGroup } from './purchaseGroup';
import { profileGroup } from './profileGroup';
import { ticketGroup } from './ticketGroup';
import { giftCardBalanceGroup } from './giftCardBalanceGroup';
import { clubsGroup } from './clubsGroup';
import { pointsGroup } from './pointsGroup';
import { contactUsGroup } from './contactUsGroup';
import { payCardGroup } from './payCardGroup';

import {
  showContactUs,
  showMyData,
  showMyPurchases,
  showMyTickets,
  showGiftcardBalance,
  showMyClubs,
  showMyPoints,
} from '../../../../constants/Visible';

const Groups = [
  showMyPurchases === 'on' ? purchaseGroup : [],
  showContactUs === 'on' ? contactUsGroup : [],
  showMyTickets === 'on' ? ticketGroup() : [],
  showMyData === 'on' ? profileGroup : [],
  showMyPoints === 'on' ? pointsGroup : [],
  showGiftcardBalance === 'on' ? giftCardBalanceGroup : [],
  showMyClubs === 'on' ? clubsGroup : [],
  payCardGroup(),
];

export default Groups;
